import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getPmsCustomer(params) {
  let url = ApiUrl.PMSCUSTOMER;
  if (params) {
    for (const paramsKey in params) {
      if (Object.hasOwnProperty.call(params, paramsKey)) {
        url += `?${paramsKey}=${params[paramsKey]}`;
      }
    }
  }
  return httpService.get(url);
}

const obj = { getPmsCustomer };

export default obj;
